import axios from 'axios';
import React, { useState, useEffect } from 'react';

import SelectComponent from '../common/select';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/get_button_option'
});

const productId = document.getElementById('mtm-customize').dataset.productId;

const MtmButton = () => {
  const [list, setList] = useState([]);

  useEffect(() => {
    const getList = async () => {
      const response = await client.get('?product_id=' + productId);
      setList(response.data.result);
    };
    getList();
  }, []);

  if (!list) return 'No button!';

  return (
    <div className="mtm-item__wrapper" id="mtm-button">
      <h3 className="mtm-item__title">BUTTON</h3>
      <div className="mtm-item__selects row row-cols-2 row-cols-md-5">
        {list.map((item, ind) => (
          <SelectComponent
            item={item}
            ind={ind}
            name="button"
            key={`${item.value}-${ind}`}
          />
        ))}
      </div>
    </div>
  );
};

export default MtmButton;
